import React from 'react';
import './PC.css';
import Candia from '../../img/PC/Candia.png'
import Ferro from '../../img/PC/Ferro.png'
import Gunn from '../../img/PC/Gunn.png'
import Corti from '../../img/PC/Corti.png'
import Bautista from '../../img/PC/Bautista.png'
import Rodionov from '../../img/PC/Rodionov.png'
import Mirabal from '../../img/PC/Mirabal.png'
import Raghavendra from '../../img/PC/Raghavendra.png'
import Umeh from '../../img/PC/Umeh.png'
import Ahmed from '../../img/PC/Ahmed.png'
import Njoroge from '../../img/PC/Njoroge.png'

export default class PC extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pc: [
        {
          photo: Candia,
          name: 'Alfredo de Candia',
          position: 'CTO - Tech Lead',
          ln: 'https://www.linkedin.com/in/alfredo-de-candia-996662178/',
          tw: 'https://twitter.com/AlfredodeCandi1',
        },
        {
          photo: Ferro,
          name: 'João Ferro',
          position: 'SME - Reverse Engineer',
          ln: 'https://www.linkedin.com/in/jgmferro/',
          tw: 'https://twitter.com/FerroLX',
        },
        {
          photo: Corti,
          name: 'Nicola Corti',
          position: 'Kotlin Google Developer Expert',
          github: 'https://github.com/cortinico',
          tw: 'https://twitter.com/cortinico',
        },
        {
          photo: Bautista,
          name: 'Pablo Bautista',
          position: 'Android Engineer',
          ln: 'https://www.linkedin.com/in/pblinux',
          tw: 'https://twitter.com/pblinux',
          github: 'https://github.com/pblinux',
        },
        {
          photo: Rodionov,
          name: 'Andrii Rodionov',
          position: 'Software Engineer',
          tw: 'https://twitter.com/andriirodionov',
        },
        {
          photo: Mirabal,
          name: 'Julio Mirabal',
          position: 'Senior Mobile Engineer',
          ln: 'https://www.linkedin.com/in/jsmirabal/',
          tw: 'https://twitter.com/jsmirabal',
        },
        {
          photo: Raghavendra,
          name: 'Raghavendra K',
          position: 'Lead Mobile Engineer',
          ln: 'https://www.linkedin.com/in/raghavendra-karamballi-a2201864/',
        },
        {
          photo: Umeh,
          name: 'Peculiar C. Umeh',
          position: 'Android Developer',
          ln: 'https://www.linkedin.com/in/peculiar-c-umeh',
          tw: 'https://twitter.com/peculiarpec',
          github: 'https://www.github.com/peculiaruc',
        },
        {
          photo: Ahmed,
          name: 'Ali Ahmed',
          position: 'Android Developer',
          ln: 'https://www.linkedin.com/in/ali-ahmed-info/',
        },
        {
          photo: Njoroge,
          name: 'Paul Njoroge',
          position: 'Senior Android Engineer',
          ln: 'https://www.linkedin.com/mwlite/in/paul-njoroge-226799197',
        },
      ]
    }
  }

  renderPC(item, i) {
    return (
      <div className="pc_item" key={`team-${i}`}>
        <div className="pc_img_block">
          <img className="team_img" src={item.photo} alt={item.name} />
        </div>
        <div className="pc_info">
          <p className="pc_name">{item.name}</p>
          <p className="pc_position">{item.position}</p>
          <div className="pc_links">
            {item.fb && <a className="pc_link social_fb" target='_blank' rel="noreferrer" href={item.fb}></a>}
            {item.ln && <a className="pc_link social_ln" target='_blank' rel="noreferrer" href={item.ln}></a>}
            {item.tw && <a className="pc_link social_tw" target='_blank' rel="noreferrer" href={item.tw}></a>}
            {item.github && <a className="pc_link social_github" target='_blank' rel="noreferrer" href={item.github}></a>}
            {item.website && <a className="pc_link social_website" target='_blank' rel="noreferrer" href={item.website}></a>}
            {item.youtube && <a className="pc_link social_yb" target='_blank' rel="noreferrer" href={item.youtube}></a>}
          </div>
        </div>
      </div>
    )
  }

  render() {
      return (
          <div className="pc container" id='pc'>
              <h3>Program committee</h3>
              <div className='pc_wrap'>
                  <div className="pc_block">
                    {this.state.pc.map((item, i) => this.renderPC(item, i))}
                  </div>
              </div>
          </div>
      )
  }
}